export function rewriteStatusMF(status, type, payment) {
  if (!status || !type) return '';
  if (type === 'withdraw') {
    switch (status) {
      case 'CONFIRMED':
        return 'Permintaan Penarikan Berhasil';
      case 'IN_PROGRESS':
        return 'Permintaan Diproses Bank Kustodian';
      case 'RECEIVED':
        return 'Permintaan Penarikan Diterima';
      default:
        return 'Dibatalkan';
    }
  }

  if (type === 'deposit') {
    switch (status) {
      case 'PROOF_UPLOADED':
        return 'Bukti Setoran Terunggah';
      case 'WAITING_PAYMENT':
        if (payment === '001') return 'Menunggu Upload Bukti';
        return 'Menunggu Pembayaran';
      case 'PAYMENT_ACCEPTED':
        return 'Setoran Diterima';
      case 'IN_PROGRESS':
        return 'Unit Reksa Dana Diproses';
      case 'CONFIRMED':
        return 'Unit Diterima';
      case 'FINAL_CHECKING':
        return 'Pemeriksaan Terakhir';
      default:
        return 'Dibatalkan';
    }
  }
}
